export default __webpack_public_path__ + "static/P118_740A2125_edited-1c0fc2632f53aa23c525edaf35861bfa.jpg";